import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  IconButton,
  CircularProgress,
  alpha
} from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { useTheme } from '@mui/material/styles';
import GlyphIcon from './GlyphIcon';

const GlyphInfoCard = ({ 
  selectedGlyph, 
  totalWords, 
  audioPlaying, 
  onPlayAudio 
}) => {
  const theme = useTheme();

  return (
    <Card 
      variant="outlined" 
      sx={{ 
        mb: 3, 
        bgcolor: theme.palette.background.paper,
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <GlyphIcon name={selectedGlyph} />
          </Grid>
          <Grid item xs>
            <Typography variant="h5" color="text.primary">
              {selectedGlyph} Glyph
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2, borderColor: alpha(theme.palette.common.white, 0.1) }} />

        <Typography variant="body1" paragraph>
          The {selectedGlyph} glyph is used in Readable English to represent a specific sound pattern.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Typography variant="subtitle2" color="primary">
            Listen to the sound:
          </Typography>
          <IconButton
            onClick={onPlayAudio}
            disabled={audioPlaying}
            size="small"
            sx={{
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              '&:hover': {
                bgcolor: alpha(theme.palette.primary.main, 0.2)
              },
              color: theme.palette.primary.main
            }}
          >
            {audioPlaying ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <VolumeUpIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Box sx={{ 
          p: 2, 
          bgcolor: alpha(theme.palette.info.main, 0.05),
          borderRadius: 1,
          border: '1px solid',
          borderColor: alpha(theme.palette.info.main, 0.3),
          mb: 2
        }}>
          <Typography variant="body2" color="text.secondary">
            This glyph appears in <strong>{totalWords}</strong> words in the Readable English system.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GlyphInfoCard;